import React from "react";
import { QRCodeCanvas } from "qrcode.react";
import { customColumnProps } from "@maherunlocker/custom-react-table";
import { t } from "i18next";
import { CustomIcons } from "./CustomIcons";
import { useSnapshot } from "valtio";
import { store } from "@components/VerticalLayout/store";

export function ArrayOfCustomColumns({
    qrCodeRefs,
    setRowData,
    setIsAddLocationClicked,
    setLocalFilterActive,
    setIsValidateDeleteOpened,
}: any): customColumnProps[] {
    const { oneShop } = useSnapshot(store);
    const setQrRef = (id: string) => (el: HTMLDivElement | null) => {
        qrCodeRefs.current[id] = el;
    };
    return [
        {
            indexOFColumn: 4,
            columnName: t("QR code"),
            customJsx: (e: any) =>
                e.selectedRow.subRows === undefined ? (
                    <div
                        className="d-flex justify-content-center align-items-center"
                        ref={setQrRef(e.selectedRow.Id)}
                    >
                        <QRCodeCanvas
                            value={e.selectedRow.qrData}
                            style={{ height: "30%", width: "30%" }}
                        />
                    </div>
                ) : (
                    <span></span>
                ),
            filterName: t("QR code"),
            canFilter: true,
        },
        {
            indexOFColumn: 99,
            columnName: t("Actions"),
            customJsx: (e: any) => (
                <CustomIcons
                    e={e}
                    qrCodeRefs={qrCodeRefs}
                    setRowData={setRowData}
                    setIsAddLocationClicked={setIsAddLocationClicked}
                    setLocalFilterActive={setLocalFilterActive}
                    setIsValidateDeleteOpened={setIsValidateDeleteOpened}
                />
            ),
        },
        {
            indexOFColumn: oneShop ? 2 : 3,
            columnName: t("Mode of sale"),
            customJsx: (e: any) =>
                e.selectedRow?.modeOfSale?.label !== undefined ? (
                    <span>{e.selectedRow.modeOfSale.label}</span>
                ) : null,
        },
    ];
}
